import React from 'react';
import ErrorPage from './ErrorPage';

export default function NotFound() {
  return <ErrorPage message="Page not found" />;
}


